module.exports = __webpack_public_path__ + "static/media/sprite.9fe52e10.png";